 import $ from 'jquery';
 import PhotoSwipe from '../plugins/photoswipe';
 import PhotoSwipeUI_Default from '../plugins/photoswipe-ui-default';

 var $galleries = null;
    var built = false;
    var pswpElement = null;



    var template = '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">' +
        '<div class="pswp__bg"></div>' +
        '<div class="pswp__scroll-wrap">' +
            '<div class="pswp__container">' +
                '<div class="pswp__item"></div>' +
                '<div class="pswp__item"></div>' +
                '<div class="pswp__item"></div>' +
            '</div>' +
            '<div class="pswp__ui pswp__ui--hidden">' +
                '<div class="pswp__top-bar">' +
                    '<div class="pswp__counter"></div>' +
                    '<button class="pswp__button pswp__button--close" title="Close (Esc)"></button>' +
                    '<button class="pswp__button pswp__button--share" title="Share"></button>' +
                    '<button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>' +
                    '<button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>' +
                    '<div class="pswp__preloader">' +
                        '<div class="pswp__preloader__icn">' +
                          '<div class="pswp__preloader__cut">' +
                            '<div class="pswp__preloader__donut"></div>' +
                          '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">' +
                    '<div class="pswp__share-tooltip"></div>' +
                '</div>' +
                '<button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">' +
                '</button>' +
                '<button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">' +
                '</button>' +
                '<div class="pswp__caption">' +
                    '<div class="pswp__caption__center"></div>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';



    function attach() {
        if (!built) {
            $(document.body).append(template);
            pswpElement = $('.pswp')[0];
            built = true
        }


        $galleries = $('.photogallery__list');
        if ($galleries.length === 0) {
            return;
        }

        $galleries.each(function(index, gallery) {
            var $links = $(this).find('a');
            var items = $links.toArray().map(function(item) {
                var size = $(item).data('img-size').split('x');
                var title = "";
                if($(item).find('.name') != null) {
                    title = $(item).find('.name').text()
                }
                if($(gallery).data('group') != null && title != "") {
                    title += ', ' + $(gallery).data('group');
                }

                return {
                    src: item.href,
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10),
                    title: title
                    //mscr: $(item).find('img')[0].src
                }
            });

            function getThumbBoundsFn(index) {
                var pos = $links.eq(index).offset();
                return  {
                    x: pos.left,
                    y: pos.top,
                    w: $links.eq(index).width()
                }
            }

            $(this).on('click.photogallery__list', 'a', function(event) {
                event.preventDefault();

                var index = $links.index(this);
                var options = {
                    index: index
                }

                var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                gallery.init();
            });

        });
    }

    function detach() {
        if ($galleries) {
            $galleries.off('click.photogallery__list');
        }

        $galleries = null;
    }

    attach();




// WEBPACK FOOTER //
// ./modules/photoswipe.js